import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import type { BulkAcceptExportPayload } from "./types";
import { bulkAcceptExportFileBaseName } from "./buildBulkAcceptExportPayload";

export function exportBulkAcceptSummaryExcel(payload: BulkAcceptExportPayload): void {
  const summaryRows: (string | number)[][] = [
    ["สรุปก่อนยืนยันรับคำสั่งซื้อ"],
    ["ชื่อผู้ประกอบการ", payload.factoryName],
    ["วันที่ส่งออก", payload.exportedAtLabel],
    [],
    ["รายการ", "จำนวน"],
    ["คำสั่งซื้อ", payload.orderCount],
    ["รายการสินค้า (ตัวเลือกสินค้า)", payload.skuCount],
    ["การสั่งซื้อ (ชิ้น)", payload.totalPieces],
    ["คำสั่งซื้อที่พร้อมยืนยัน", payload.readyToConfirmCount],
    ["คำสั่งซื้อที่ไม่พร้อมยืนยัน", payload.notReadyToConfirmCount],
  ];

  const skuHeader = ["ลำดับ", "ชื่อสินค้า", "ชื่อ SKU", "จำนวน (ชิ้น)", "สถานะ"];
  const skuBody = payload.skuRows.map((row) => [
    row.rank,
    row.productName,
    row.skuLabel,
    row.qty,
    row.statusLabel,
  ]);

  const wsSummary = XLSX.utils.aoa_to_sheet(summaryRows);
  wsSummary["!cols"] = [{ wch: 32 }, { wch: 18 }];

  const wsSku = XLSX.utils.aoa_to_sheet([skuHeader, ...skuBody]);
  wsSku["!cols"] = [
    { wch: 8 },
    { wch: 36 },
    { wch: 28 },
    { wch: 14 },
    { wch: 18 },
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, wsSummary, "สรุป");
  XLSX.utils.book_append_sheet(wb, wsSku, "รายการ SKU");

  const buffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `${bulkAcceptExportFileBaseName()}.xlsx`);
}
